@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.weight {
  display: flex;
  align-items: center;
  color: @weight-input--text-color;
  min-width: 0;
}
